module.exports = __webpack_public_path__ + "img/w.1d9fe4be.png";